module.exports = __webpack_public_path__ + "img/manage-default.096f0dae.svg";